import { api } from "../../configs/api";
import { nextStepCredStepper } from "../../configs/utils";
import { ROUTE } from "../../routes";
import SharedPropsService from "../../SharedPropsService";
import { getAppHeader } from "../../configs/config";
export const openContactUsCard = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.CONTACT_US_CARD);
};
export const retryUserContextAPI = async (action, _datastore, { network, navigateWithClear, setDatastore }) => {
    await setDatastore(ROUTE.USER_CONTEXT_500, "userContext500Page", {
        loading: true
    });
    const user = await network.post(api.userContext, {}, {
        headers: await getAppHeader(),
    });
    await SharedPropsService.setUser(user.data);
    if (user.status === 200) {
        await setDatastore(ROUTE.USER_CONTEXT_500, "userContext500Page", {
            loading: false
        });
        const currentStepId = user.data.linkedApplications[0].currentStepId;
        const routeObj = await nextStepCredStepper(currentStepId);
        await navigateWithClear(routeObj.routeId, routeObj.params);
    }
    else {
        await setDatastore(ROUTE.USER_CONTEXT_500, "userContext500Page", {
            loading: false
        });
    }
};
